import { useEffect, useRef } from 'react';
import { useMsal } from '@azure/msal-react';
import { useProductsContext } from '../context/ProductsContext';
import { capture, identify, isAnalyticsEnabled } from './posthog';

export function useIdentifyUser() {
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const oid = account?.localAccountId;
  const email = account?.username;
  const name = account?.name;

  const { userRole, userRoles, isAdmin, isLeadership, initialized } = useProductsContext();

  const signedInFiredFor = useRef(null);

  useEffect(() => {
    if (!isAnalyticsEnabled() || !oid) return;

    identify(oid, {
      email,
      name,
      role: userRole,
      roles: userRoles,
      is_admin: isAdmin,
      is_leadership: isLeadership,
    });

    if (initialized && signedInFiredFor.current !== oid) {
      capture('user_signed_in');
      signedInFiredFor.current = oid;
    }
  }, [oid, email, name, userRole, userRoles, isAdmin, isLeadership, initialized]);
}
